export class DataFilter {
  public query: string;
  public errorType: string;
  public sectionName: string;
}
